
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Sorting} from './Sorting';
import {FieldModelSorting} from './Sorting';
import {SortingEnum} from './SortingEnum';
import {FieldModelSortingEnum} from './SortingEnum';
import {SocialTradingMasterAccountSorting} from '../core/SocialTradingMasterAccountSorting';
import {FieldModelSocialTradingMasterAccountSorting} from '../core/SocialTradingMasterAccountSorting';
import {SocialTradingInvestorAccountSorting} from '../core/SocialTradingInvestorAccountSorting';
import {FieldModelSocialTradingInvestorAccountSorting} from '../core/SocialTradingInvestorAccountSorting';

/**
 * AccountSorting struct
 */
class AccountSorting {
  /**
   * Initialize struct
   * @param {Sorting=} login
   * @param {Sorting=} name
   * @param {Sorting=} country
   * @param {Sorting=} city
   * @param {Sorting=} state
   * @param {Sorting=} zipCode
   * @param {Sorting=} address
   * @param {Sorting=} phone
   * @param {Sorting=} email
   * @param {Sorting=} identifier
   * @param {Sorting=} status
   * @param {Sorting=} comment
   * @param {Sorting=} description
   * @param {Sorting=} isEnabled
   * @param {Sorting=} deprecated_IsOTPEnabled
   * @param {Sorting=} isTradeEnabled
   * @param {SortingEnum=} authenticationType
   * @param {SortingEnum=} accountingType
   * @param {Sorting=} agentAccount
   * @param {Sorting=} maxPendingOrders
   * @param {Sorting=} created
   * @param {Sorting=} modified
   * @param {Sorting=} archived
   * @param {Sorting=} deleted
   * @param {Sorting=} lastLogin
   * @param {SortingEnum=} reportsSubscriptionType
   * @param {Sorting=} maxOrders
   * @param {Sorting=} externalClientId
   * @param {Sorting=} externalAccountId
   * @param {Sorting=} localLanguageName
   * @param {SortingEnum=} socialTradingAccountType
   * @param {SocialTradingMasterAccountSorting=} socialTradingMasterAccountSorting
   * @param {SocialTradingInvestorAccountSorting=} socialTradingInvestorAccountSorting
   * @constructor
   */
  constructor (login = null, name = null, country = null, city = null, state = null, zipCode = null, address = null, phone = null, email = null, identifier = null, status = null, comment = null, description = null, isEnabled = null, deprecated_IsOTPEnabled = null, isTradeEnabled = null, authenticationType = null, accountingType = null, agentAccount = null, maxPendingOrders = null, created = null, modified = null, archived = null, deleted = null, lastLogin = null, reportsSubscriptionType = null, maxOrders = null, externalClientId = null, externalAccountId = null, localLanguageName = null, socialTradingAccountType = null, socialTradingMasterAccountSorting = null, socialTradingInvestorAccountSorting = null) {
    this.Login = login
    this.Name = name
    this.Country = country
    this.City = city
    this.State = state
    this.ZipCode = zipCode
    this.Address = address
    this.Phone = phone
    this.Email = email
    this.Identifier = identifier
    this.Status = status
    this.Comment = comment
    this.Description = description
    this.IsEnabled = isEnabled
    this.Deprecated_IsOTPEnabled = deprecated_IsOTPEnabled
    this.IsTradeEnabled = isTradeEnabled
    this.AuthenticationType = authenticationType
    this.AccountingType = accountingType
    this.AgentAccount = agentAccount
    this.MaxPendingOrders = maxPendingOrders
    this.Created = created
    this.Modified = modified
    this.Archived = archived
    this.Deleted = deleted
    this.LastLogin = lastLogin
    this.ReportsSubscriptionType = reportsSubscriptionType
    this.MaxOrders = maxOrders
    this.ExternalClientId = externalClientId
    this.ExternalAccountId = externalAccountId
    this.LocalLanguageName = localLanguageName
    this.SocialTradingAccountType = socialTradingAccountType
    this.SocialTradingMasterAccountSorting = socialTradingMasterAccountSorting
    this.SocialTradingInvestorAccountSorting = socialTradingInvestorAccountSorting
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountSorting}
   * @param {!AccountSorting} other Other struct
   * @returns {!AccountSorting} This struct
   */
  copy (other) {
    if (other.Login != null) {
      this.Login = Sorting.fromObject(other.Login)
    } else {
      this.Login = null
    }
    if (other.Name != null) {
      this.Name = Sorting.fromObject(other.Name)
    } else {
      this.Name = null
    }
    if (other.Country != null) {
      this.Country = Sorting.fromObject(other.Country)
    } else {
      this.Country = null
    }
    if (other.City != null) {
      this.City = Sorting.fromObject(other.City)
    } else {
      this.City = null
    }
    if (other.State != null) {
      this.State = Sorting.fromObject(other.State)
    } else {
      this.State = null
    }
    if (other.ZipCode != null) {
      this.ZipCode = Sorting.fromObject(other.ZipCode)
    } else {
      this.ZipCode = null
    }
    if (other.Address != null) {
      this.Address = Sorting.fromObject(other.Address)
    } else {
      this.Address = null
    }
    if (other.Phone != null) {
      this.Phone = Sorting.fromObject(other.Phone)
    } else {
      this.Phone = null
    }
    if (other.Email != null) {
      this.Email = Sorting.fromObject(other.Email)
    } else {
      this.Email = null
    }
    if (other.Identifier != null) {
      this.Identifier = Sorting.fromObject(other.Identifier)
    } else {
      this.Identifier = null
    }
    if (other.Status != null) {
      this.Status = Sorting.fromObject(other.Status)
    } else {
      this.Status = null
    }
    if (other.Comment != null) {
      this.Comment = Sorting.fromObject(other.Comment)
    } else {
      this.Comment = null
    }
    if (other.Description != null) {
      this.Description = Sorting.fromObject(other.Description)
    } else {
      this.Description = null
    }
    if (other.IsEnabled != null) {
      this.IsEnabled = Sorting.fromObject(other.IsEnabled)
    } else {
      this.IsEnabled = null
    }
    if (other.Deprecated_IsOTPEnabled != null) {
      this.Deprecated_IsOTPEnabled = Sorting.fromObject(other.Deprecated_IsOTPEnabled)
    } else {
      this.Deprecated_IsOTPEnabled = null
    }
    if (other.IsTradeEnabled != null) {
      this.IsTradeEnabled = Sorting.fromObject(other.IsTradeEnabled)
    } else {
      this.IsTradeEnabled = null
    }
    if (other.AuthenticationType != null) {
      this.AuthenticationType = SortingEnum.fromObject(other.AuthenticationType)
    } else {
      this.AuthenticationType = null
    }
    if (other.AccountingType != null) {
      this.AccountingType = SortingEnum.fromObject(other.AccountingType)
    } else {
      this.AccountingType = null
    }
    if (other.AgentAccount != null) {
      this.AgentAccount = Sorting.fromObject(other.AgentAccount)
    } else {
      this.AgentAccount = null
    }
    if (other.MaxPendingOrders != null) {
      this.MaxPendingOrders = Sorting.fromObject(other.MaxPendingOrders)
    } else {
      this.MaxPendingOrders = null
    }
    if (other.Created != null) {
      this.Created = Sorting.fromObject(other.Created)
    } else {
      this.Created = null
    }
    if (other.Modified != null) {
      this.Modified = Sorting.fromObject(other.Modified)
    } else {
      this.Modified = null
    }
    if (other.Archived != null) {
      this.Archived = Sorting.fromObject(other.Archived)
    } else {
      this.Archived = null
    }
    if (other.Deleted != null) {
      this.Deleted = Sorting.fromObject(other.Deleted)
    } else {
      this.Deleted = null
    }
    if (other.LastLogin != null) {
      this.LastLogin = Sorting.fromObject(other.LastLogin)
    } else {
      this.LastLogin = null
    }
    if (other.ReportsSubscriptionType != null) {
      this.ReportsSubscriptionType = SortingEnum.fromObject(other.ReportsSubscriptionType)
    } else {
      this.ReportsSubscriptionType = null
    }
    if (other.MaxOrders != null) {
      this.MaxOrders = Sorting.fromObject(other.MaxOrders)
    } else {
      this.MaxOrders = null
    }
    if (other.ExternalClientId != null) {
      this.ExternalClientId = Sorting.fromObject(other.ExternalClientId)
    } else {
      this.ExternalClientId = null
    }
    if (other.ExternalAccountId != null) {
      this.ExternalAccountId = Sorting.fromObject(other.ExternalAccountId)
    } else {
      this.ExternalAccountId = null
    }
    if (other.LocalLanguageName != null) {
      this.LocalLanguageName = Sorting.fromObject(other.LocalLanguageName)
    } else {
      this.LocalLanguageName = null
    }
    if (other.SocialTradingAccountType != null) {
      this.SocialTradingAccountType = SortingEnum.fromObject(other.SocialTradingAccountType)
    } else {
      this.SocialTradingAccountType = null
    }
    if (other.SocialTradingMasterAccountSorting != null) {
      this.SocialTradingMasterAccountSorting = SocialTradingMasterAccountSorting.fromObject(other.SocialTradingMasterAccountSorting)
    } else {
      this.SocialTradingMasterAccountSorting = null
    }
    if (other.SocialTradingInvestorAccountSorting != null) {
      this.SocialTradingInvestorAccountSorting = SocialTradingInvestorAccountSorting.fromObject(other.SocialTradingInvestorAccountSorting)
    } else {
      this.SocialTradingInvestorAccountSorting = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountSorting}
   * @returns {!AccountSorting} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountSortingModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountSortingModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountSorting}
   * @param {!AccountSorting} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountSorting)) {
      throw new TypeError('Instance of AccountSorting is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountSorting}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Login: ((this.Login != null) ? this.Login : null),
      Name: ((this.Name != null) ? this.Name : null),
      Country: ((this.Country != null) ? this.Country : null),
      City: ((this.City != null) ? this.City : null),
      State: ((this.State != null) ? this.State : null),
      ZipCode: ((this.ZipCode != null) ? this.ZipCode : null),
      Address: ((this.Address != null) ? this.Address : null),
      Phone: ((this.Phone != null) ? this.Phone : null),
      Email: ((this.Email != null) ? this.Email : null),
      Identifier: ((this.Identifier != null) ? this.Identifier : null),
      Status: ((this.Status != null) ? this.Status : null),
      Comment: ((this.Comment != null) ? this.Comment : null),
      Description: ((this.Description != null) ? this.Description : null),
      IsEnabled: ((this.IsEnabled != null) ? this.IsEnabled : null),
      Deprecated_IsOTPEnabled: ((this.Deprecated_IsOTPEnabled != null) ? this.Deprecated_IsOTPEnabled : null),
      IsTradeEnabled: ((this.IsTradeEnabled != null) ? this.IsTradeEnabled : null),
      AuthenticationType: ((this.AuthenticationType != null) ? this.AuthenticationType : null),
      AccountingType: ((this.AccountingType != null) ? this.AccountingType : null),
      AgentAccount: ((this.AgentAccount != null) ? this.AgentAccount : null),
      MaxPendingOrders: ((this.MaxPendingOrders != null) ? this.MaxPendingOrders : null),
      Created: ((this.Created != null) ? this.Created : null),
      Modified: ((this.Modified != null) ? this.Modified : null),
      Archived: ((this.Archived != null) ? this.Archived : null),
      Deleted: ((this.Deleted != null) ? this.Deleted : null),
      LastLogin: ((this.LastLogin != null) ? this.LastLogin : null),
      ReportsSubscriptionType: ((this.ReportsSubscriptionType != null) ? this.ReportsSubscriptionType : null),
      MaxOrders: ((this.MaxOrders != null) ? this.MaxOrders : null),
      ExternalClientId: ((this.ExternalClientId != null) ? this.ExternalClientId : null),
      ExternalAccountId: ((this.ExternalAccountId != null) ? this.ExternalAccountId : null),
      LocalLanguageName: ((this.LocalLanguageName != null) ? this.LocalLanguageName : null),
      SocialTradingAccountType: ((this.SocialTradingAccountType != null) ? this.SocialTradingAccountType : null),
      SocialTradingMasterAccountSorting: ((this.SocialTradingMasterAccountSorting != null) ? this.SocialTradingMasterAccountSorting : null),
      SocialTradingInvestorAccountSorting: ((this.SocialTradingInvestorAccountSorting != null) ? this.SocialTradingInvestorAccountSorting : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountSorting.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountSorting} other Object value
   * @returns {!AccountSorting} Created struct
   */
  static fromObject (other) {
    return new AccountSorting().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountSorting}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountSorting.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountSorting}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 150
  }
}

export { AccountSorting };

/**
 * Fast Binary Encoding AccountSorting field model
 */
class FieldModelAccountSorting extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Login = new fbe.FieldModelOptional(new FieldModelSorting(buffer, 4 + 4), buffer, 4 + 4)
    this.Name = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Login.fbeOffset + this.Login.fbeSize), buffer, this.Login.fbeOffset + this.Login.fbeSize)
    this.Country = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Name.fbeOffset + this.Name.fbeSize), buffer, this.Name.fbeOffset + this.Name.fbeSize)
    this.City = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Country.fbeOffset + this.Country.fbeSize), buffer, this.Country.fbeOffset + this.Country.fbeSize)
    this.State = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.City.fbeOffset + this.City.fbeSize), buffer, this.City.fbeOffset + this.City.fbeSize)
    this.ZipCode = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.State.fbeOffset + this.State.fbeSize), buffer, this.State.fbeOffset + this.State.fbeSize)
    this.Address = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.ZipCode.fbeOffset + this.ZipCode.fbeSize), buffer, this.ZipCode.fbeOffset + this.ZipCode.fbeSize)
    this.Phone = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Address.fbeOffset + this.Address.fbeSize), buffer, this.Address.fbeOffset + this.Address.fbeSize)
    this.Email = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Phone.fbeOffset + this.Phone.fbeSize), buffer, this.Phone.fbeOffset + this.Phone.fbeSize)
    this.Identifier = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Email.fbeOffset + this.Email.fbeSize), buffer, this.Email.fbeOffset + this.Email.fbeSize)
    this.Status = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Identifier.fbeOffset + this.Identifier.fbeSize), buffer, this.Identifier.fbeOffset + this.Identifier.fbeSize)
    this.Comment = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Status.fbeOffset + this.Status.fbeSize), buffer, this.Status.fbeOffset + this.Status.fbeSize)
    this.Description = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Comment.fbeOffset + this.Comment.fbeSize), buffer, this.Comment.fbeOffset + this.Comment.fbeSize)
    this.IsEnabled = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Description.fbeOffset + this.Description.fbeSize), buffer, this.Description.fbeOffset + this.Description.fbeSize)
    this.Deprecated_IsOTPEnabled = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.IsEnabled.fbeOffset + this.IsEnabled.fbeSize), buffer, this.IsEnabled.fbeOffset + this.IsEnabled.fbeSize)
    this.IsTradeEnabled = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Deprecated_IsOTPEnabled.fbeOffset + this.Deprecated_IsOTPEnabled.fbeSize), buffer, this.Deprecated_IsOTPEnabled.fbeOffset + this.Deprecated_IsOTPEnabled.fbeSize)
    this.AuthenticationType = new fbe.FieldModelOptional(new FieldModelSortingEnum(buffer, this.IsTradeEnabled.fbeOffset + this.IsTradeEnabled.fbeSize), buffer, this.IsTradeEnabled.fbeOffset + this.IsTradeEnabled.fbeSize)
    this.AccountingType = new fbe.FieldModelOptional(new FieldModelSortingEnum(buffer, this.AuthenticationType.fbeOffset + this.AuthenticationType.fbeSize), buffer, this.AuthenticationType.fbeOffset + this.AuthenticationType.fbeSize)
    this.AgentAccount = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.AccountingType.fbeOffset + this.AccountingType.fbeSize), buffer, this.AccountingType.fbeOffset + this.AccountingType.fbeSize)
    this.MaxPendingOrders = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.AgentAccount.fbeOffset + this.AgentAccount.fbeSize), buffer, this.AgentAccount.fbeOffset + this.AgentAccount.fbeSize)
    this.Created = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.MaxPendingOrders.fbeOffset + this.MaxPendingOrders.fbeSize), buffer, this.MaxPendingOrders.fbeOffset + this.MaxPendingOrders.fbeSize)
    this.Modified = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Created.fbeOffset + this.Created.fbeSize), buffer, this.Created.fbeOffset + this.Created.fbeSize)
    this.Archived = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Modified.fbeOffset + this.Modified.fbeSize), buffer, this.Modified.fbeOffset + this.Modified.fbeSize)
    this.Deleted = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Archived.fbeOffset + this.Archived.fbeSize), buffer, this.Archived.fbeOffset + this.Archived.fbeSize)
    this.LastLogin = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize), buffer, this.Deleted.fbeOffset + this.Deleted.fbeSize)
    this.ReportsSubscriptionType = new fbe.FieldModelOptional(new FieldModelSortingEnum(buffer, this.LastLogin.fbeOffset + this.LastLogin.fbeSize), buffer, this.LastLogin.fbeOffset + this.LastLogin.fbeSize)
    this.MaxOrders = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.ReportsSubscriptionType.fbeOffset + this.ReportsSubscriptionType.fbeSize), buffer, this.ReportsSubscriptionType.fbeOffset + this.ReportsSubscriptionType.fbeSize)
    this.ExternalClientId = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.MaxOrders.fbeOffset + this.MaxOrders.fbeSize), buffer, this.MaxOrders.fbeOffset + this.MaxOrders.fbeSize)
    this.ExternalAccountId = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize), buffer, this.ExternalClientId.fbeOffset + this.ExternalClientId.fbeSize)
    this.LocalLanguageName = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.ExternalAccountId.fbeOffset + this.ExternalAccountId.fbeSize), buffer, this.ExternalAccountId.fbeOffset + this.ExternalAccountId.fbeSize)
    this.SocialTradingAccountType = new fbe.FieldModelOptional(new FieldModelSortingEnum(buffer, this.LocalLanguageName.fbeOffset + this.LocalLanguageName.fbeSize), buffer, this.LocalLanguageName.fbeOffset + this.LocalLanguageName.fbeSize)
    this.SocialTradingMasterAccountSorting = new fbe.FieldModelOptional(new FieldModelSocialTradingMasterAccountSorting(buffer, this.SocialTradingAccountType.fbeOffset + this.SocialTradingAccountType.fbeSize), buffer, this.SocialTradingAccountType.fbeOffset + this.SocialTradingAccountType.fbeSize)
    this.SocialTradingInvestorAccountSorting = new fbe.FieldModelOptional(new FieldModelSocialTradingInvestorAccountSorting(buffer, this.SocialTradingMasterAccountSorting.fbeOffset + this.SocialTradingMasterAccountSorting.fbeSize), buffer, this.SocialTradingMasterAccountSorting.fbeOffset + this.SocialTradingMasterAccountSorting.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountSorting}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountSorting}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Login.fbeSize + this.Name.fbeSize + this.Country.fbeSize + this.City.fbeSize + this.State.fbeSize + this.ZipCode.fbeSize + this.Address.fbeSize + this.Phone.fbeSize + this.Email.fbeSize + this.Identifier.fbeSize + this.Status.fbeSize + this.Comment.fbeSize + this.Description.fbeSize + this.IsEnabled.fbeSize + this.Deprecated_IsOTPEnabled.fbeSize + this.IsTradeEnabled.fbeSize + this.AuthenticationType.fbeSize + this.AccountingType.fbeSize + this.AgentAccount.fbeSize + this.MaxPendingOrders.fbeSize + this.Created.fbeSize + this.Modified.fbeSize + this.Archived.fbeSize + this.Deleted.fbeSize + this.LastLogin.fbeSize + this.ReportsSubscriptionType.fbeSize + this.MaxOrders.fbeSize + this.ExternalClientId.fbeSize + this.ExternalAccountId.fbeSize + this.LocalLanguageName.fbeSize + this.SocialTradingAccountType.fbeSize + this.SocialTradingMasterAccountSorting.fbeSize + this.SocialTradingInvestorAccountSorting.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountSorting}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Login.fbeExtra + this.Name.fbeExtra + this.Country.fbeExtra + this.City.fbeExtra + this.State.fbeExtra + this.ZipCode.fbeExtra + this.Address.fbeExtra + this.Phone.fbeExtra + this.Email.fbeExtra + this.Identifier.fbeExtra + this.Status.fbeExtra + this.Comment.fbeExtra + this.Description.fbeExtra + this.IsEnabled.fbeExtra + this.Deprecated_IsOTPEnabled.fbeExtra + this.IsTradeEnabled.fbeExtra + this.AuthenticationType.fbeExtra + this.AccountingType.fbeExtra + this.AgentAccount.fbeExtra + this.MaxPendingOrders.fbeExtra + this.Created.fbeExtra + this.Modified.fbeExtra + this.Archived.fbeExtra + this.Deleted.fbeExtra + this.LastLogin.fbeExtra + this.ReportsSubscriptionType.fbeExtra + this.MaxOrders.fbeExtra + this.ExternalClientId.fbeExtra + this.ExternalAccountId.fbeExtra + this.LocalLanguageName.fbeExtra + this.SocialTradingAccountType.fbeExtra + this.SocialTradingMasterAccountSorting.fbeExtra + this.SocialTradingInvestorAccountSorting.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountSorting}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountSorting.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountSorting}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 150
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountSorting}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountSorting}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Login.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Login.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Name.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Country.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Country.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Country.fbeSize

    if ((fbeCurrentSize + this.City.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.City.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.City.fbeSize

    if ((fbeCurrentSize + this.State.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.State.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.State.fbeSize

    if ((fbeCurrentSize + this.ZipCode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ZipCode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ZipCode.fbeSize

    if ((fbeCurrentSize + this.Address.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Address.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Address.fbeSize

    if ((fbeCurrentSize + this.Phone.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Phone.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Phone.fbeSize

    if ((fbeCurrentSize + this.Email.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Email.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Email.fbeSize

    if ((fbeCurrentSize + this.Identifier.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Identifier.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Identifier.fbeSize

    if ((fbeCurrentSize + this.Status.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Status.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Comment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Description.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.Deprecated_IsOTPEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deprecated_IsOTPEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated_IsOTPEnabled.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsTradeEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabled.fbeSize

    if ((fbeCurrentSize + this.AuthenticationType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AuthenticationType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AuthenticationType.fbeSize

    if ((fbeCurrentSize + this.AccountingType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountingType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountingType.fbeSize

    if ((fbeCurrentSize + this.AgentAccount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AgentAccount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AgentAccount.fbeSize

    if ((fbeCurrentSize + this.MaxPendingOrders.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MaxPendingOrders.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxPendingOrders.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Created.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Modified.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Archived.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Deleted.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.LastLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastLogin.fbeSize

    if ((fbeCurrentSize + this.ReportsSubscriptionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ReportsSubscriptionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReportsSubscriptionType.fbeSize

    if ((fbeCurrentSize + this.MaxOrders.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MaxOrders.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxOrders.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalClientId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.ExternalAccountId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExternalAccountId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalAccountId.fbeSize

    if ((fbeCurrentSize + this.LocalLanguageName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LocalLanguageName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LocalLanguageName.fbeSize

    if ((fbeCurrentSize + this.SocialTradingAccountType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingAccountType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingAccountType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingMasterAccountSorting.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingMasterAccountSorting.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingMasterAccountSorting.fbeSize

    if ((fbeCurrentSize + this.SocialTradingInvestorAccountSorting.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SocialTradingInvestorAccountSorting.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingInvestorAccountSorting.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountSorting}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountSorting}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountSorting}
   * @param {!AccountSorting} fbeValue Default value, defaults is new AccountSorting()
   * @returns {!AccountSorting} AccountSorting value
   */
  get (fbeValue = new AccountSorting()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountSorting}
   * @param {!AccountSorting} fbeValue AccountSorting value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Login.fbeSize) <= fbeStructSize) {
      fbeValue.Login = this.Login.get()
    } else {
      fbeValue.Login = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) <= fbeStructSize) {
      fbeValue.Name = this.Name.get()
    } else {
      fbeValue.Name = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Country.fbeSize) <= fbeStructSize) {
      fbeValue.Country = this.Country.get()
    } else {
      fbeValue.Country = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Country.fbeSize

    if ((fbeCurrentSize + this.City.fbeSize) <= fbeStructSize) {
      fbeValue.City = this.City.get()
    } else {
      fbeValue.City = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.City.fbeSize

    if ((fbeCurrentSize + this.State.fbeSize) <= fbeStructSize) {
      fbeValue.State = this.State.get()
    } else {
      fbeValue.State = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.State.fbeSize

    if ((fbeCurrentSize + this.ZipCode.fbeSize) <= fbeStructSize) {
      fbeValue.ZipCode = this.ZipCode.get()
    } else {
      fbeValue.ZipCode = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ZipCode.fbeSize

    if ((fbeCurrentSize + this.Address.fbeSize) <= fbeStructSize) {
      fbeValue.Address = this.Address.get()
    } else {
      fbeValue.Address = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Address.fbeSize

    if ((fbeCurrentSize + this.Phone.fbeSize) <= fbeStructSize) {
      fbeValue.Phone = this.Phone.get()
    } else {
      fbeValue.Phone = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Phone.fbeSize

    if ((fbeCurrentSize + this.Email.fbeSize) <= fbeStructSize) {
      fbeValue.Email = this.Email.get()
    } else {
      fbeValue.Email = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Email.fbeSize

    if ((fbeCurrentSize + this.Identifier.fbeSize) <= fbeStructSize) {
      fbeValue.Identifier = this.Identifier.get()
    } else {
      fbeValue.Identifier = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Identifier.fbeSize

    if ((fbeCurrentSize + this.Status.fbeSize) <= fbeStructSize) {
      fbeValue.Status = this.Status.get()
    } else {
      fbeValue.Status = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) <= fbeStructSize) {
      fbeValue.Comment = this.Comment.get()
    } else {
      fbeValue.Comment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) <= fbeStructSize) {
      fbeValue.Description = this.Description.get()
    } else {
      fbeValue.Description = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsEnabled = this.IsEnabled.get()
    } else {
      fbeValue.IsEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.Deprecated_IsOTPEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.Deprecated_IsOTPEnabled = this.Deprecated_IsOTPEnabled.get()
    } else {
      fbeValue.Deprecated_IsOTPEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deprecated_IsOTPEnabled.fbeSize

    if ((fbeCurrentSize + this.IsTradeEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsTradeEnabled = this.IsTradeEnabled.get()
    } else {
      fbeValue.IsTradeEnabled = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsTradeEnabled.fbeSize

    if ((fbeCurrentSize + this.AuthenticationType.fbeSize) <= fbeStructSize) {
      fbeValue.AuthenticationType = this.AuthenticationType.get()
    } else {
      fbeValue.AuthenticationType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AuthenticationType.fbeSize

    if ((fbeCurrentSize + this.AccountingType.fbeSize) <= fbeStructSize) {
      fbeValue.AccountingType = this.AccountingType.get()
    } else {
      fbeValue.AccountingType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountingType.fbeSize

    if ((fbeCurrentSize + this.AgentAccount.fbeSize) <= fbeStructSize) {
      fbeValue.AgentAccount = this.AgentAccount.get()
    } else {
      fbeValue.AgentAccount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AgentAccount.fbeSize

    if ((fbeCurrentSize + this.MaxPendingOrders.fbeSize) <= fbeStructSize) {
      fbeValue.MaxPendingOrders = this.MaxPendingOrders.get()
    } else {
      fbeValue.MaxPendingOrders = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxPendingOrders.fbeSize

    if ((fbeCurrentSize + this.Created.fbeSize) <= fbeStructSize) {
      fbeValue.Created = this.Created.get()
    } else {
      fbeValue.Created = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Created.fbeSize

    if ((fbeCurrentSize + this.Modified.fbeSize) <= fbeStructSize) {
      fbeValue.Modified = this.Modified.get()
    } else {
      fbeValue.Modified = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Modified.fbeSize

    if ((fbeCurrentSize + this.Archived.fbeSize) <= fbeStructSize) {
      fbeValue.Archived = this.Archived.get()
    } else {
      fbeValue.Archived = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Archived.fbeSize

    if ((fbeCurrentSize + this.Deleted.fbeSize) <= fbeStructSize) {
      fbeValue.Deleted = this.Deleted.get()
    } else {
      fbeValue.Deleted = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Deleted.fbeSize

    if ((fbeCurrentSize + this.LastLogin.fbeSize) <= fbeStructSize) {
      fbeValue.LastLogin = this.LastLogin.get()
    } else {
      fbeValue.LastLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastLogin.fbeSize

    if ((fbeCurrentSize + this.ReportsSubscriptionType.fbeSize) <= fbeStructSize) {
      fbeValue.ReportsSubscriptionType = this.ReportsSubscriptionType.get()
    } else {
      fbeValue.ReportsSubscriptionType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReportsSubscriptionType.fbeSize

    if ((fbeCurrentSize + this.MaxOrders.fbeSize) <= fbeStructSize) {
      fbeValue.MaxOrders = this.MaxOrders.get()
    } else {
      fbeValue.MaxOrders = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MaxOrders.fbeSize

    if ((fbeCurrentSize + this.ExternalClientId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalClientId = this.ExternalClientId.get()
    } else {
      fbeValue.ExternalClientId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalClientId.fbeSize

    if ((fbeCurrentSize + this.ExternalAccountId.fbeSize) <= fbeStructSize) {
      fbeValue.ExternalAccountId = this.ExternalAccountId.get()
    } else {
      fbeValue.ExternalAccountId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExternalAccountId.fbeSize

    if ((fbeCurrentSize + this.LocalLanguageName.fbeSize) <= fbeStructSize) {
      fbeValue.LocalLanguageName = this.LocalLanguageName.get()
    } else {
      fbeValue.LocalLanguageName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LocalLanguageName.fbeSize

    if ((fbeCurrentSize + this.SocialTradingAccountType.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingAccountType = this.SocialTradingAccountType.get()
    } else {
      fbeValue.SocialTradingAccountType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingAccountType.fbeSize

    if ((fbeCurrentSize + this.SocialTradingMasterAccountSorting.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingMasterAccountSorting = this.SocialTradingMasterAccountSorting.get()
    } else {
      fbeValue.SocialTradingMasterAccountSorting = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingMasterAccountSorting.fbeSize

    if ((fbeCurrentSize + this.SocialTradingInvestorAccountSorting.fbeSize) <= fbeStructSize) {
      fbeValue.SocialTradingInvestorAccountSorting = this.SocialTradingInvestorAccountSorting.get()
    } else {
      fbeValue.SocialTradingInvestorAccountSorting = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SocialTradingInvestorAccountSorting.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountSorting}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountSorting}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountSorting}
   * @param {!AccountSorting} fbeValue AccountSorting value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountSorting}
   * @param {AccountSorting} fbeValue AccountSorting value
   */
  setFields (fbeValue) {
    this.Login.set(fbeValue.Login)
    this.Name.set(fbeValue.Name)
    this.Country.set(fbeValue.Country)
    this.City.set(fbeValue.City)
    this.State.set(fbeValue.State)
    this.ZipCode.set(fbeValue.ZipCode)
    this.Address.set(fbeValue.Address)
    this.Phone.set(fbeValue.Phone)
    this.Email.set(fbeValue.Email)
    this.Identifier.set(fbeValue.Identifier)
    this.Status.set(fbeValue.Status)
    this.Comment.set(fbeValue.Comment)
    this.Description.set(fbeValue.Description)
    this.IsEnabled.set(fbeValue.IsEnabled)
    this.Deprecated_IsOTPEnabled.set(fbeValue.Deprecated_IsOTPEnabled)
    this.IsTradeEnabled.set(fbeValue.IsTradeEnabled)
    this.AuthenticationType.set(fbeValue.AuthenticationType)
    this.AccountingType.set(fbeValue.AccountingType)
    this.AgentAccount.set(fbeValue.AgentAccount)
    this.MaxPendingOrders.set(fbeValue.MaxPendingOrders)
    this.Created.set(fbeValue.Created)
    this.Modified.set(fbeValue.Modified)
    this.Archived.set(fbeValue.Archived)
    this.Deleted.set(fbeValue.Deleted)
    this.LastLogin.set(fbeValue.LastLogin)
    this.ReportsSubscriptionType.set(fbeValue.ReportsSubscriptionType)
    this.MaxOrders.set(fbeValue.MaxOrders)
    this.ExternalClientId.set(fbeValue.ExternalClientId)
    this.ExternalAccountId.set(fbeValue.ExternalAccountId)
    this.LocalLanguageName.set(fbeValue.LocalLanguageName)
    this.SocialTradingAccountType.set(fbeValue.SocialTradingAccountType)
    this.SocialTradingMasterAccountSorting.set(fbeValue.SocialTradingMasterAccountSorting)
    this.SocialTradingInvestorAccountSorting.set(fbeValue.SocialTradingInvestorAccountSorting)
  }
}

export { FieldModelAccountSorting };

/**
 * Fast Binary Encoding AccountSorting model
 */
class AccountSortingModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountSorting(this.buffer, 4)
  }

  /**
   * Get the AccountSorting model
   * @this {!AccountSortingModel}
   * @returns {!FieldModelAccountSorting} model AccountSorting model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountSortingModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountSortingModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountSortingModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountSortingModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountSorting.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountSortingModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountSortingModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountSortingModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountSortingModel}
   * @param {!AccountSorting} value AccountSorting value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountSortingModel}
   * @param {!AccountSorting} value AccountSorting value, defaults is new AccountSorting()
   * @return {!object} Deserialized AccountSorting value and its size
   */
  deserialize (value = new AccountSorting()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountSorting(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountSorting(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountSortingModel}
   * @param {!number} prev Previous AccountSorting model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountSortingModel };
